import { useEffect } from 'react';
import { useSnackbar } from '@gemini/ui';
import { trackingSuffix } from '@mfe-presentation/constants/trackingSuffix';
import { useAppContext } from '@mfe-presentation/contexts';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';

export const useSuccessSnackbar = (): void => {
    const {
        formValues: { isPropertyOwner, isAPrivatePerson },
        isAuthenticated,
    } = useAppContext();
    const { t } = useTranslation(NAME_SPACE);
    const { success } = useSnackbar();

    useEffect(() => {
        if (isPropertyOwner && isAPrivatePerson && isAuthenticated) {
            success({
                description: t('step_results.success_snackbar.description'),
                action: {
                    children: t('step_results.success_snackbar.button'),
                    href: `${process.env['NX_CONSUMER_PORTAL_URL']}${trackingSuffix}`,
                },
                variant: 'success',
                actionType: 'long',
                testId: 'success-snackbar',
            });
        }
    }, []);
};
